import React from "react";
import Star from "./Star";

const starsClassSwitch = val => {
  switch (true) {
    case val < 6:
      return "0";
    case val > 5 && val < 24:
      return "16";
    case val > 23 && val < 45:
      return "33";
    case val > 44 && val < 56:
      return "50";
    case val > 55 && val < 75:
      return "66";
    case val > 74 && val < 90:
      return "82";
    case val > 90:
      return "100";
  }
};

const calculateFillPercentage = (rating, index) => {
  if (index <= rating) {
    return "100";
  } else if (index > Math.ceil(rating)) {
    return "0";
  } else {
    return starsClassSwitch(Math.floor((rating - Math.floor(rating)) * 100));
  }
};

const RatingStars = ({ rating, size, maxRating, className }) => {
  for (var i = 1, stars = []; i <= maxRating; i++) {
    stars.push(
      <Star
        key={i}
        className={className}
        fillPercentage={calculateFillPercentage(rating, i)}
        size={size}
      />
    );
  }
  return <span>{stars}</span>;
};

RatingStars.defaultProps = {
  size: "19px",
  rating: 3.0,
  maxRating: 5
};

export default RatingStars;
